import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "monitoringEvent-sidebar-page-content" }
const _hoisted_2 = { class: "events-sidebar__previews" }
const _hoisted_3 = { class: "frame" }
const _hoisted_4 = { class: "frame__overview" }
const _hoisted_5 = { class: "frame__header label-m" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_7 = { class: "frame" }
const _hoisted_8 = { class: "frame__overview" }
const _hoisted_9 = { class: "frame__header label-m" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "frame"
}
const _hoisted_12 = { class: "frame__overview" }
const _hoisted_13 = { class: "frame__header label-m" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_15 = {
  key: 1,
  class: "frame"
}
const _hoisted_16 = { class: "frame__overview" }
const _hoisted_17 = { class: "frame__header label-m" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_19 = {
  key: 2,
  class: "frame"
}
const _hoisted_20 = { class: "frame__overview" }
const _hoisted_21 = { class: "frame__header label-m" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_23 = {
  key: 3,
  class: "frame"
}
const _hoisted_24 = { class: "frame__overview" }
const _hoisted_25 = { class: "frame__header label-m" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_27 = { class: "frame" }
const _hoisted_28 = { class: "frame__overview" }
const _hoisted_29 = { class: "frame__header label-m" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_31 = { class: "frame" }
const _hoisted_32 = { class: "frame__overview" }
const _hoisted_33 = { class: "frame__header label-m" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_35 = { class: "frame" }
const _hoisted_36 = { class: "frame__overview" }
const _hoisted_37 = { class: "frame__header label-m" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_39 = { class: "frame acknowledgment" }
const _hoisted_40 = { class: "frame__overview" }
const _hoisted_41 = { class: "frame__header label-m" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NThumbnail = _resolveComponent("NThumbnail")!
  const _component_MatchedCardInfo = _resolveComponent("MatchedCardInfo")!
  const _component_WatchListsGroup = _resolveComponent("WatchListsGroup")!
  const _component_NForm = _resolveComponent("NForm")!
  const _component_Acknowledge = _resolveComponent("Acknowledge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NThumbnail, {
        class: "events-sidebar__previews-event",
        actions: _ctx.thumbnailActions,
        "model-value": _ctx.item.thumbnail,
        size: "extra-large",
        onAction: _ctx.showFullscreen
      }, null, 8, ["actions", "model-value", "onAction"]),
      _createVNode(_component_MatchedCardInfo, {
        id: _ctx.item.card,
        type: 'humans',
        "object-id": _ctx.item.face_object_id,
        "object-type": 'faces',
        confidence: _ctx.item.confidence
      }, null, 8, ["id", "object-id", "confidence"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('common.watch_lists', 'f')), 1),
        _hoisted_6
      ]),
      (_ctx.card?.watch_lists)
        ? (_openBlock(), _createBlock(_component_WatchListsGroup, {
            key: 0,
            items: _ctx.card.watch_lists,
            "tag-view": "",
            "text-size": "normal"
          }, null, 8, ["items"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('common.camera', 'f')), 1),
        _hoisted_10
      ]),
      _createTextVNode(" " + _toDisplayString(_ctx.item.camera), 1)
    ]),
    (_ctx.item.name)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('common.name', 'f')), 1),
            _hoisted_14
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.item.name), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.item.address)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('common.address', 'f')), 1),
            _hoisted_18
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.item.address), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.item.longitude && _ctx.item.latitude)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('common.location', 'f')), 1),
            _hoisted_22
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.item.longitude) + ", " + _toDisplayString(_ctx.item.latitude), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.item.azimuth)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('common.azimuth', 'f')), 1),
            _hoisted_26
          ]),
          _createTextVNode(" " + _toDisplayString(_ctx.item.azimuth) + "° ", 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('remote_monitoring.source', 'f')), 1),
        _hoisted_30
      ]),
      _createTextVNode(" " + _toDisplayString(_ctx.item.puppet_id), 1)
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('common.info', 'f')), 1),
        _hoisted_34
      ]),
      _createVNode(_component_NForm, {
        layout: _ctx.infoFields,
        model: _ctx.item
      }, null, 8, ["layout", "model"])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('common.reason', 'f')), 1),
        _hoisted_38
      ]),
      _createTextVNode(" " + _toDisplayString(_ctx.reasons), 1)
    ]),
    _createElementVNode("div", _hoisted_39, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t('common.acknowledgement', 'f')), 1),
        _hoisted_42
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_Acknowledge, {
          class: "monitoringEvent-sidebar-page-content__acknowledge",
          item: _ctx.item,
          onAction: _ctx.acknowledge,
          disabled: _ctx.item.acknowledged || !_ctx.modelAcl.update
        }, null, 8, ["item", "onAction", "disabled"])
      ])
    ]),
    _hoisted_43
  ]))
}